import useLocalDataStore from "@/hooks/common/useLocalDataStore";
import useOverlay, {OverlayState} from "@/hooks/common/useOverlay";
import Alert from "@COMPONENTS/common/modal/alert/Mobile";
import {FilterType} from "@COMPONENTS/product/common/popup/desktop/EventListPopup/EventListPopup";
import * as style from "@COMPONENTS/style/productlist/trafficM";
import {PopupContainer} from "@FRAMEWORK/ui/mobile/popup";
import {Traffic} from "@QUERIES/prdt/goods/useGoodsOption";
import React from "react";

interface Props {
	goodsCd: string;
	trafficList: Traffic[];
}

const TrafficPopup = ({trafficList, goodsCd, ...overlayProps}: Props & OverlayState) => {
	const key = "trCompanySnm";
	const {getLocalData, addLocalData, setLocalData} = useLocalDataStore();
	const filters = (getLocalData("departureFilters") as FilterType[]) ?? [];
	const [showAlert] = useOverlay();

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const {checked, value} = e.target;
		const text = e.target.parentNode.lastChild.textContent;

		if (checked) {
			const hasFilter = filters.some(item => item.value === value && item.key === key);

			if (hasFilter) return;
			addLocalData({key: "departureFilters", value: {key, value, text}});
		} else {
			if (filters.filter(v => v.key === "trCompanySnm").length === 1) {
				return showAlert(props => <Alert {...props} text="교통편은 최소 1개 이상 선택하셔야 합니다." />);
			}

			setLocalData({
				key: "departureFilters",
				value: filters.filter(item => !(item.value === value && item.key === key)),
			});
		}
	};

	const initialize = () => {
		const trafficsExcluded = filters.filter(e => e.key !== key);
		const allTraffics = trafficList.map(tr => ({key, value: tr.trCompanySnm, text: tr.trCompanyNm}));
		setLocalData({key: "departureFilters", value: [...trafficsExcluded, ...allTraffics]});
	};

	return (
		<PopupContainer
			{...overlayProps}
			title="교통편 선택"
			animate="slideIn"
			size="toast"
			icon={<style.IconButton onClick={initialize} />}
		>
			<style.CheckList>
				{trafficList.map((traffic, index) => (
					<style.CheckListItem key={index}>
						<input
							type="checkbox"
							id={`airline${goodsCd}${index}`}
							value={traffic.trCompanySnm}
							checked={filters.some(v => v.value === traffic.trCompanySnm) || false}
							onChange={handleChange}
						/>
						<label htmlFor={`airline${goodsCd}${index}`}>
							<span>{traffic.trCompanyNm}</span>
						</label>
					</style.CheckListItem>
				))}
			</style.CheckList>
		</PopupContainer>
	);
};

export default TrafficPopup;
